import _each from "lodash/each";

export default class CatalogModule {
  constructor() {
    this.setupModule();
  }

  setupModule() {
    this.module = {
      state: {
        catalogIndex: 0
      },

      getters: {},

      // Mutations ----------------------------------------
      mutations: {
        catalogClick(state, payload) {
          state.catalogIndex = payload.catalogIndex;
        }
      },
      // Actions ----------------------------------------
      actions: {
        // 使用イベントの登録
        catalogClick({ commit, state }, payload) {
          commit("catalogClick", payload);
        }
      }
    };
  }

  getModule() {
    return this.module;
  }
}
